import { Record } from "immutable"

const Tag = Record({
  id: 0,
  name: "",
  color: ""
})

export default Tag
